module.exports = __webpack_public_path__ + "static/media/secondary-3-science.4cca9b13.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/secondary-3-science.png
// module id = 173
// module chunks = 0